import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { H2, Carousel, spacingHelper, typographyHelper } from '@construct-kit/core';
import { useInView } from 'react-intersection-observer';
import type {
  ElitePlusCarouselListing,
  ElitePlusCarouselListingBucket,
} from '../../model/elitePlusCarouselListingResponse';
import ElitePlusCarouselListingCard from './ElitePlusCarouselListingCard';
import trackingAdapter from '../../tracking/trackingAdapter';

const Title = styled(H2)`
  margin: 0 0 ${spacingHelper('medium')};
  ${typographyHelper('title02')};
  ${({ theme }) => theme.layoutBreakpoints.large} {
    ${typographyHelper('title01')};
  }
`;

export type ElitePlusCarouselComponentProps = {
  listings: ElitePlusCarouselListing[];
  bucket: ElitePlusCarouselListingBucket;
};

const ElitePlusCarouselComponent: React.FunctionComponent<ElitePlusCarouselComponentProps> = ({
  listings,
  bucket,
}) => {
  const [isTrackingSent, setIsTrackingSent] = useState<boolean>(false);

  const handleScroll = () => {
    if (!isTrackingSent) {
      trackingAdapter.trackCarouselInteraction({
        inPageSource: bucket === 'featured' ? 'explore_new_properties' : 'suggested_properties',
      });
      setIsTrackingSent(true);
    }
  };

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 1,
  });
  useEffect(() => {
    if (inView) {
      trackingAdapter.trackElitePlusCarouselImpressionEvent(listings, bucket);
    }
  }, [inView]);

  return (
    <div ref={ref}>
      <Title>
        {bucket === 'featured' ? 'Explore new properties' : 'Suggested properties for you'}
      </Title>
      <Carousel
        insideGap="medium"
        outsideGap="0"
        showScrollButtons="auto"
        onScroll={handleScroll}
        scrollDistancePercentage={50}
      >
        {listings.map((listing) => (
          <ElitePlusCarouselListingCard key={listing.pdpUrl} listing={listing} bucket={bucket} />
        ))}
      </Carousel>
    </div>
  );
};

export default ElitePlusCarouselComponent;
